<template>
  <div class="user-box">
    <div class="user">
      <div class="avatar-img">
        <img :src="avatar" v-if="avatar" />
        <img src="../../assets/images/noavatar_middle.gif" v-else />
      </div>
      <div class="avatar-info">
        <div>
          <h1>{{nickname}}</h1>
          <p>{{mobile}}</p>
          <p>
            <van-tag round @click="$router.push('/user/edit')">
              编辑个人信息
              <van-icon name="arrow" />
            </van-tag>
          </p>
        </div>
      </div>
    </div>
 
  </div>
</template>

<script>
var root = process.env.VUE_APP_API_URL;
import Footbar from "../commpents/footbar";

import { Toast, Cell, CellGroup, Button, Icon, Row, Col, Tag } from "vant";

export default {
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Toast.name]: Toast,
    [Tag.name]: Tag,
    Footbar
  },

  data() {
    return {};
  },
  props: {
    nickname: {
      type: String,
      default: "房产小儿"
    },
    mobile: {
      type: String,
      default: "13880000000"
    },
    avatar: String,
    agentStatus: Number
  },
  mounted() {},

  methods: {}
};
</script>

<style scoped>
.user-box {
  width: 100%;
  color: #fff;
  background-image: url("../../assets/images/userbanner.png");
  background-size: cover;
  height: 90px;
  padding-top: 15px;
  position: relative;
}
.user {
  display: flex;
  height: 70px;
  align-items: center;
  margin-left: 20px;
}
.user-zhongjie {
  background-color: #fff;
  height: 40px;
  position: absolute;
  width: 80%;
  border-radius: 20px;
  bottom: 0;
  left: 10%;
  text-align: left;
  color: #666;
  display: flex;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  justify-content: space-between;
  align-items: center;
}
.user-zhongjie-txt {
  margin: 0 15px;
  font-size: 14px;
}
.user-zhongjie-btn {
  background-color: #f4682b;
  color: #fff;
  height: 24px;
  padding: 0 8px;
  width: 60px;
  text-align: center;
  line-height: 24px;
  border-radius: 4px;
  margin: 0 15px;
  font-size: 12px;
}
.avatar-img {
  width: 60px;
  height: 60px;
  border-radius: 100%;
  background-color: #fff;
  display: flex;
}
.avatar-img img {
  width: 100%;
  border-radius: 100%;
}
.avatar-info {
  margin-left: 10px;
  display: flex;
}
.avatar-info h1 {
  font-size: 16px;
  font-weight: 200;
}
.avatar-info p {
  font-size: 12px;
  color: #fff;
  padding: 0 0;
}
.avatar-info p .van-tag {
  margin: 2px 0 0 0;
}
</style>>



